import Cookies from "js-cookie";
import API from "./API";

// For endpoints that can only be used from the supportal.
export default class SupportalAPI {
  static async changeModuleApiName(
    tenantID: string,
    oldAPIName: string,
    newAPIName: string
  ) {
    return API._bearerRequest(
      "PUT",
      `/tenant/settings/crm/modules/${oldAPIName}/renameTo/${newAPIName}?tenantID=${tenantID}`,
      null,
      Cookies.get(`authenticationToken`)
    );
  }

  static async renameFieldAPIName(
    tenantID: string,
    moduleAPIName: string,
    oldAPIName: string,
    newAPIName: string
  ) {
    return API._bearerRequest(
      "PUT",
      `/tenant/settings/crm/modules/${moduleAPIName}/fields/${oldAPIName}/renameTo/${newAPIName}?tenantID=${tenantID}`,
      null,
      Cookies.get(`authenticationToken`)
    );
  }
}
